(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-week-collection-banner"]) return;
  try {
    
document.addEventListener("shopify:section:load", () => {
        document.getElementById("FilterGridWrapper").appendChild(document.getElementById("BlackWeekBanner"));
        document.getElementById("BlackWeekBanner").classList.remove("hidden");
    }
);
document.addEventListener("shopify:section:unload", () => {
    document.getElementById("BlackWeekBanner").remove();
});
document.addEventListener("DOMContentLoaded", () => {
        document.getElementById("FilterGridWrapper").appendChild(document.getElementById("BlackWeekBanner"));
        document.getElementById("BlackWeekBanner").classList.remove("hidden");
    }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
function initialize(){
  document.querySelectorAll(".collection-selection").forEach((collectionSelection)=>{
    collectionSelection.querySelectorAll("[data-show-collection]").forEach((target)=>{
      target.addEventListener("click",()=>{
        collectionSelection.querySelectorAll(".collection-block").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.collectionId == target.dataset.showCollection);
        });
        collectionSelection.querySelectorAll("[data-show-collection]").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.showCollection == target.dataset.showCollection);
        });
      });
      target.addEventListener("keydown",(e)=>{
        if (event.key != "Enter") { return }

        collectionSelection.querySelectorAll(".collection-block").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.collectionId == target.dataset.showCollection);
        });
        collectionSelection.querySelectorAll("[data-show-collection]").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.showCollection == target.dataset.showCollection);
        });
      });
      target.classList.remove("hidden");
    })
  });
}
document.addEventListener("DOMContentLoaded", () => initialize());
document.addEventListener('shopify:section:load', () => initialize());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.centerContent();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView({block: "center"});

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    centerContent() {
      let content = this.querySelector(".product-media-modal__content");
      let is_mobile = window.matchMedia("screen and (max-width: 750px)").matches
      if(is_mobile){
        content.scrollTop = (content.scrollHeight - content.clientHeight) / 2
      }
    }
  }
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', FeaturedProductModal);
  }

  class FeaturedInventoryCountdown extends HTMLElement {
    constructor() {
      super();

      this.barElement = this.querySelector('.sg__inventory_countdown > span');
      this.counterElement = this.querySelector('.sg_inventory_counter_text');
      this.counterText = this.dataset.counterText;

      this.currentInventory = parseInt(this.dataset.currentInventory);
      this.totalInventory = parseInt(this.dataset.totalInventory);
      this.relInventory = this.currentInventory / this.totalInventory * 100;

      this.hasLowInventory = this.classList.contains('low-inventory');
      this.useAbsoluteValues = this.dataset.useAbsoluteValues === 'true';
      this.duration = parseInt(this.dataset.duration) * 1000;

      this.classList.remove('hidden');
      this.classList.add('active');

      if (this.duration > 0 && 'IntersectionObserver' in window && 'requestAnimationFrame' in window) {
        this.initAnimation();
      }
    }

    initAnimation() {
      this.barElement.style.width = '100%';
      this.classList.remove('low-inventory');

      const startValue = this.useAbsoluteValues ? this.totalInventory : 100;
      this.counterElement.textContent = this.counterText.replace('$(inventory)', startValue);

      // Set timeout to avoid applying transition on just changed css values
      setTimeout(() => {
        this.barElement.style.transition = `width ${this.duration}ms, background-color ${this.duration}ms`;
        this.counterElement.style.transition = `color ${this.duration}ms`;
        this.initObserver();
      }, 0);
    }

    initObserver() {
      if (!('IntersectionObserver' in window && 'requestAnimationFrame' in window)) {
        this.finalize();
        return;
      }

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {rootMargin: "0px 0px -10px 0px"});

      observer.observe(this);
    }

    animate() {
      this.barElement.style.width = `${this.relInventory}%`;
      this.classList.toggle('low-inventory', this.hasLowInventory);

      this.start = performance.now();
      requestAnimationFrame(timestamp => this.frame(timestamp));
    }

    frame(timestamp) {
        const elapsed = timestamp - this.start;
        const delta = (this.duration - elapsed) / this.duration;
        const value = this.currentInventory + (this.totalInventory - this.currentInventory) * delta;
        this.counterElement.textContent = this.counterText.replace('$(inventory)', this.getValueForText(value))
        if (elapsed < this.duration) { requestAnimationFrame(timestamp => this.frame(timestamp)); }
        else { this.finalize(); }
    }

    finalize() {
      this.barElement.style.width = `${this.relInventory}%`;
      this.counterElement.textContent = this.counterText.replace('$(inventory)', this.getValueForText(this.currentInventory));
      this.classList.toggle('low-inventory', this.hasLowInventory);
    }

    getValueForText(value) {
      return Math.ceil(this.useAbsoluteValues ? value : value / this.totalInventory * 100);
    }
  }

  if (!customElements.get('inventory-countdown')) {
    customElements.define('inventory-countdown',FeaturedInventoryCountdown);
  }

  document.querySelectorAll(".linked-product-buttons > .button.button--secondary").forEach(e => {
    const group_switcher = e.parentElement.parentElement;
    const current_variant = group_switcher.querySelector(".linked-product-current-variant");
    e.addEventListener("mouseenter",() => {
      current_variant.textContent = e.title;
    })
    e.addEventListener("mouseout", () => {
      current_variant.textContent = group_switcher.querySelector(".button.button--primary").title;
    })
  })

  class FeaturedUnifiedVariantDropdown extends HTMLElement{
    constructor(){
      super();
      const variantSelects = this.querySelector("variant-selects");
      const resetVariant = this.dataset.resetVariant;
      this.querySelectorAll(".variant-dropdown-select").forEach(entry =>{
        entry.querySelector(".variant-option--selected").addEventListener("click", () => { 
  
          if(entry.getAttribute("open") == "true"){
            entry.setAttribute("open", "false");
            entry.addEventListener("pointerleave",() => {
              entry.removeAttribute("open");
            }, {once: true});
          }else{
            entry.setAttribute("open", "true");
            entry.addEventListener("pointerleave",() => {
              setTimeout(e=>{
                if(entry.getAttribute("open") == "false"){
                  entry.removeAttribute("open");
                }
              },0)
            }, {once: true});
          }
        });
      });
  
      this.querySelectorAll(".variant-option:not(.variant-option--selected)").forEach(entry =>{
        entry.addEventListener("mouseenter", (e) => {
          if(window.matchMedia("(max-width: 750px)").matches){
            return;
          }
          variantSelects.changeVariant(entry.dataset.variantId);
          
          entry.addEventListener("mouseleave", () => {
            variantSelects.changeVariant(resetVariant);
          }, { once: true })
        });
      })
    }
  }

  if (!customElements.get('sg-unified-variant-dropdown')) {
    customElements.define('sg-unified-variant-dropdown', FeaturedUnifiedVariantDropdown);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*let searchInputPosition = 'desktop';
  function moveSearchInputOnResize() {
    const mobileParentSelector = '.menu-drawer__search-lang-container';
    const desktopParentSelector = '.search-modal__content';
    const breakPoint = 990;

    // Search input is first child of parents
    let searchInput, newParent, newPosition;
    if (window.innerWidth < breakPoint && searchInputPosition !== 'mobile') {
      searchInput = document.querySelector(desktopParentSelector).firstChild;
      newParent = document.querySelector(mobileParentSelector);
      newPosition = 'mobile';
    }
    if (window.innerWidth >= breakPoint && searchInputPosition !== 'desktop') {
      searchInput = document.querySelector(mobileParentSelector).firstChild;
      newParent = document.querySelector(desktopParentSelector);
      newPosition = 'desktop';
    }
    if (!searchInput || !newParent) {
      return;
    }
    newParent.prepend(searchInput);
    searchInputPosition = newPosition;
  }
  window.addEventListener('resize', moveSearchInputOnResize);
  moveSearchInputOnResize();*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-grouped"]) return;
  try {
    
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.productsContainerSelector = this.getAttribute('data-products-container');
    this.paginationSelector = this.getAttribute('data-pagination-selector');
    this.nextPageSelector = this.getAttribute('data-next-page-selector');
    this.productsContainerEl = this.querySelector(this.productsContainerSelector);
    this.paginationEl = this.querySelector(this.paginationSelector);
    this.loadingIndicator = this.querySelector('.loading-overlay-wrapper');

    if (!this.productsContainerEl || !this.paginationEl) {
      return;
    }

    try {
      this.observer = this.registerObserver(this.loadNextPage.bind(this));
      this.observer.observe(this.paginationEl);
      this.paginationEl.style.visibility = 'hidden';
    } catch (error) {}

  }

  registerObserver(callback) {
    let callbackIsRunning = false
    return new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !callbackIsRunning) {
        callbackIsRunning = true;
        callback()
          .then(_ => callbackIsRunning = false)
          .catch(_ => callbackIsRunning = false);
      }
    })
  }

  loadNextPage() {
    const nextPageEl = this.paginationEl.querySelector(this.nextPageSelector);
    if (!nextPageEl) {
      this.observer.disconnect();
      return Promise.resolve();
    }
    const nextPageUrl = nextPageEl.getAttribute('href');
    this.loadingIndicator.classList.remove('hidden');
    return fetch(nextPageUrl)
      .then(result => {
        this.loadingIndicator.classList.add('hidden')
        if (!result.ok) {
          throw(result.statusText);
        }
        return result.text()
      })
      .then(this.handleNextPage.bind(this))
  }

  handleNextPage(nextPageContent) {
    const nextPageHtml = new DOMParser().parseFromString(nextPageContent, 'text/html')
    const nextPageProducts = nextPageHtml.querySelector(this.productsContainerSelector)
    if (!nextPageProducts) {
      console.warn('Infinite scroll: Could not find any products in next page', nextPageHtml);
      return;
    }
    this.productsContainerEl.insertAdjacentHTML('beforeend', nextPageProducts.innerHTML);
    window.postMessage({
      type: 'next_page_loaded',
      selector: this.id,
    }, '*');
    const nextPagePagination = nextPageHtml.querySelector(this.paginationSelector);
    if (!nextPagePagination) {
      return;
    }
    this.paginationEl.innerHTML = nextPagePagination.innerHTML;
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.productsContainerSelector = this.getAttribute('data-products-container');
    this.paginationSelector = this.getAttribute('data-pagination-selector');
    this.nextPageSelector = this.getAttribute('data-next-page-selector');
    this.productsContainerEl = this.querySelector(this.productsContainerSelector);
    this.paginationEl = this.querySelector(this.paginationSelector);
    this.loadingIndicator = this.querySelector('.loading-overlay-wrapper');

    if (!this.productsContainerEl || !this.paginationEl) {
      return;
    }

    try {
      this.observer = this.registerObserver(this.loadNextPage.bind(this));
      this.observer.observe(this.paginationEl);
      this.paginationEl.style.visibility = 'hidden';
    } catch (error) {}

  }

  registerObserver(callback) {
    let callbackIsRunning = false
    return new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !callbackIsRunning) {
        callbackIsRunning = true;
        callback()
          .then(_ => callbackIsRunning = false)
          .catch(_ => callbackIsRunning = false);
      }
    })
  }

  loadNextPage() {
    const nextPageEl = this.paginationEl.querySelector(this.nextPageSelector);
    if (!nextPageEl) {
      this.observer.disconnect();
      return Promise.resolve();
    }
    const nextPageUrl = nextPageEl.getAttribute('href');
    this.loadingIndicator.classList.remove('hidden');
    return fetch(nextPageUrl)
      .then(result => {
        this.loadingIndicator.classList.add('hidden')
        if (!result.ok) {
          throw(result.statusText);
        }
        return result.text()
      })
      .then(this.handleNextPage.bind(this))
  }

  handleNextPage(nextPageContent) {
    const nextPageHtml = new DOMParser().parseFromString(nextPageContent, 'text/html')
    const nextPageProducts = nextPageHtml.querySelector(this.productsContainerSelector)
    if (!nextPageProducts) {
      console.warn('Infinite scroll: Could not find any products in next page', nextPageHtml);
      return;
    }
    this.productsContainerEl.insertAdjacentHTML('beforeend', nextPageProducts.innerHTML);
    window.postMessage({
      type: 'next_page_loaded',
      selector: this.id,
    }, '*');
    const nextPagePagination = nextPageHtml.querySelector(this.paginationSelector);
    if (!nextPagePagination) {
      return;
    }
    this.paginationEl.innerHTML = nextPagePagination.innerHTML;
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.centerContent();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView({block: "center"});

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }

    centerContent() {
      let content = this.querySelector(".product-media-modal__content");
      let is_mobile = window.matchMedia("screen and (max-width: 750px)").matches
      if(is_mobile){
        content.scrollTop = (content.scrollHeight - content.clientHeight) / 2
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  class InventoryCountdown extends HTMLElement {
    constructor() {
      super();

      this.barElement = this.querySelector('.sg__inventory_countdown > span');
      this.counterElement = this.querySelector('.sg_inventory_counter_text');
      this.counterText = this.dataset.counterText;

      this.currentInventory = parseInt(this.dataset.currentInventory);
      this.totalInventory = parseInt(this.dataset.totalInventory);
      this.relInventory = this.currentInventory / this.totalInventory * 100;

      this.hasLowInventory = this.classList.contains('low-inventory');
      this.useAbsoluteValues = this.dataset.useAbsoluteValues === 'true';
      this.duration = parseInt(this.dataset.duration) * 1000;

      this.classList.remove('hidden');
      this.classList.add('active');

      if (this.duration > 0 && 'IntersectionObserver' in window && 'requestAnimationFrame' in window) {
        this.initAnimation();
      }
    }

    initAnimation() {
      this.barElement.style.width = '100%';
      this.classList.remove('low-inventory');

      const startValue = this.useAbsoluteValues ? this.totalInventory : 100;
      this.counterElement.textContent = this.counterText.replace('$(inventory)', startValue);

      // Set timeout to avoid applying transition on just changed css values
      setTimeout(() => {
        this.barElement.style.transition = `width ${this.duration}ms, background-color ${this.duration}ms`;
        this.counterElement.style.transition = `color ${this.duration}ms`;
        this.initObserver();
      }, 0);
    }

    initObserver() {
      if (!('IntersectionObserver' in window && 'requestAnimationFrame' in window)) {
        this.finalize();
        return;
      }

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      }, {rootMargin: "0px 0px -10px 0px"});

      observer.observe(this);
    }

    animate() {
      this.barElement.style.width = `${this.relInventory}%`;
      this.classList.toggle('low-inventory', this.hasLowInventory);

      this.start = performance.now();
      requestAnimationFrame(timestamp => this.frame(timestamp));
    }

    frame(timestamp) {
        const elapsed = timestamp - this.start;
        const delta = (this.duration - elapsed) / this.duration;
        const value = this.currentInventory + (this.totalInventory - this.currentInventory) * delta;
        this.counterElement.textContent = this.counterText.replace('$(inventory)', this.getValueForText(value))
        if (elapsed < this.duration) { requestAnimationFrame(timestamp => this.frame(timestamp)); }
        else { this.finalize(); }
    }

    finalize() {
      this.barElement.style.width = `${this.relInventory}%`;
      this.counterElement.textContent = this.counterText.replace('$(inventory)', this.getValueForText(this.currentInventory));
      this.classList.toggle('low-inventory', this.hasLowInventory);
    }

    getValueForText(value) {
      return Math.ceil(this.useAbsoluteValues ? value : value / this.totalInventory * 100);
    }
  }

  customElements.define('inventory-countdown', InventoryCountdown);

  document.querySelectorAll(".linked-product-buttons > .button.button--secondary").forEach(e => {
    const group_switcher = e.parentElement.parentElement;
    const current_variant = group_switcher.querySelector(".linked-product-current-variant");
    e.addEventListener("mouseenter",() => {
      current_variant.textContent = e.title;
    })
    e.addEventListener("mouseout", () => {
      current_variant.textContent = group_switcher.querySelector(".button.button--primary").title;
    })
  })

  class UnifiedVariantDropdown extends HTMLElement{
    constructor(){
      super();
      const variantSelects = this.querySelector("variant-selects");
      const resetVariant = this.dataset.resetVariant;
      this.querySelectorAll(".variant-dropdown-select").forEach(entry =>{
        entry.querySelector(".variant-option--selected").addEventListener("click", () => { 
          if(window.matchMedia("(max-width: 750px)").matches){
            return;
          }
          if(entry.getAttribute("open") == "true"){
            entry.setAttribute("open", "false");
            entry.addEventListener("pointerleave",() => {
              entry.removeAttribute("open");
            }, {once: true});
          }else{
            entry.setAttribute("open", "true");
            entry.addEventListener("pointerleave",() => {
              setTimeout(e=>{
                if(entry.getAttribute("open") == "false"){
                  entry.removeAttribute("open");
                }
              },0)
            }, {once: true});
          }
        });
      });
  
      this.querySelectorAll(".variant-option:not(.variant-option--selected)").forEach(entry =>{
        entry.addEventListener("mouseenter", (e) => {
          if(window.matchMedia("(max-width: 750px)").matches){
            return;
          }
          variantSelects.changeVariant(entry.dataset.variantId);
          
          entry.addEventListener("mouseleave", () => {
            variantSelects.changeVariant(resetVariant);
          }, { once: true })
        });
      })
    }
  }

  customElements.define('sg-unified-variant-dropdown', UnifiedVariantDropdown);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neocom-embedded-collection-banner"]) return;
  try {
    
document.addEventListener("shopify:section:load", () => {
        document.getElementById("product-grid").appendChild(document.getElementById("NeocomCollectionBanner"));
        document.getElementById("NeocomCollectionBanner").classList.remove("hidden");
    }
);
document.addEventListener("shopify:section:unload", () => {
    document.getElementById("NeocomCollectionBanner").remove();
});
document.addEventListener("DOMContentLoaded", () => {
        document.getElementById("product-grid").appendChild(document.getElementById("NeocomCollectionBanner"));
        document.getElementById("NeocomCollectionBanner").classList.remove("hidden");
    }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-navigation"]) return;
  try {
    

function setActiveLink(links, activeLink){
    links.forEach((link) => link.classList.remove("active"));
    if (activeLink) {
      activeLink.classList.add("active");
      activeLink.parentElement.scrollLeft = activeLink.offsetLeft;
    }
}
function preventStickyHeaderShowing(){
  let stickyHeader = document.querySelector('sticky-header');
  if(stickyHeader) {
    stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }
}

function setupNavigation(navigation) {
  const sections = Array.from(navigation.parentElement.parentElement.querySelectorAll(".shopify-section"));
  const sectionOffset = sections.indexOf(navigation.parentElement)

  const links = Array.from(navigation.querySelectorAll("[data-targets]"));
  const sectionLinkMapping = {};

  for(let link of links){
    for(let targetSectionIdx of link.dataset.targets.split(",")){
      let target = sections[sectionOffset + parseInt(targetSectionIdx)];
      sectionLinkMapping[target.id] = link;
      if (!link.dataset.target){ link.dataset.target = "#" + target.id; }
    }
    link.addEventListener("click", () => {
      setActiveLink(links, link);
      preventStickyHeaderShowing();
      window.scrollTo(0, document.querySelector(link.dataset.target).offsetTop - navigation.clientHeight);
      //document.querySelector(link.dataset.target).scrollIntoView();
    });
  }
  navigation.classList.remove("hidden");

  let scrollRightButton = navigation.querySelector(".scroll-right-icon");
  if (scrollRightButton){
    scrollRightButton.addEventListener("click", () => {
      let active_link_index = links.findIndex((link) =>
          link.classList.contains("active")
        );

      if (active_link_index == -1) {
        for(let link of links){
          if(link.offsetLeft > navigation.scrollLeft){
            navigation.scrollLeft = link.offsetLeft;
            break;
          }
        }
      }
      else if(active_link_index+1 < links.length){
        links[active_link_index+1].click();
      }
    })
  }

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          sectionLinkMapping[entry.target.id].classList.toggle("visible", entry.isIntersecting);
        });
        let first_visible_link = links.find((link) =>
          link.classList.contains("visible")
        );
        setActiveLink(links, first_visible_link);
      },
      {
        rootMargin: "-200px 0px 0px 0px",
        threshold: [0, 0.01, 0.025, 0.05, 0.075, 0.1, 0.5, 0.75, 0.95, 1]
      }
    );
    for(let link of links){
      for(let targetSectionIdx of link.dataset.targets.split(",")){
        let target = sections[sectionOffset + parseInt(targetSectionIdx)];
        io.observe(target);
      }
    }

    document.addEventListener("shopify:section:unload", () => io.disconnect(), { once: true });

  }
}
document.addEventListener("DOMContentLoaded", () =>
  document.querySelectorAll(".product-navigation").forEach(setupNavigation)
);

document.addEventListener("shopify:section:load", () =>
  document.querySelectorAll(".product-navigation").forEach(setupNavigation)
);

function updateNavigationPosition() {
  let product_navigations = document.querySelectorAll(".product-navigation");
  for (let product_navigation of product_navigations){
    product_navigation.classList.toggle(
      "product-navigation--mobile",
      product_navigation.scrollWidth > product_navigation.clientWidth
    );
  }
}
document.addEventListener("DOMContentLoaded", updateNavigationPosition);
window.addEventListener("resize", updateNavigationPosition);
document.addEventListener("shopify:section:load", updateNavigationPosition);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.postMessage({
                type: 'product_recommendations_loaded',
                selector: this.id,
              }, '*');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".sg__quotes").forEach(quotes => {
    const quotesContainer = quotes.querySelector(".sg__quotes-container")
    const quotesSelector = quotes.querySelector(".sg__quotes-selector")
    const counter = quotes.querySelector(".sg__quotes-progress .current")

    let current_index = 1
    const interval = parseInt(quotes.dataset.interval)*1000;

    const switch_to_index = function(index) {
        quotesContainer.querySelectorAll(".active")
            .forEach(quote => quote.classList.remove("active"))
        quotesContainer.querySelector(`div:nth-child(${index})`).classList.add("active");

        quotesSelector.querySelectorAll(".active")
            .forEach(link => link.classList.remove("active"))
        quotesSelector.querySelector(`a:nth-child(${index})`).classList.add("active");

        counter.textContent = index
        current_index = index
        // console.log(index)
    }

    //setInterval(()=>switch_to_index((current_index % quotesContainer.children.length) + 1), interval)

    quotesSelector.querySelectorAll("a").forEach(a => a.addEventListener("click", () => switch_to_index(parseInt(a.dataset.index))))
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  class RelatedProducts extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const products = html.querySelector('related-products');
            if (products && products.innerHTML.trim().length) {
              this.innerHTML = products.innerHTML;
              this.showRandomItems();
              window.postMessage({
                type: 'product_recommendations_loaded',
                selector: this.id,
              }, '*');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    showRandomItems = function () {
      const items = this.querySelectorAll(`.grid__item[data-type="${window.product_type}"]`);
      const itemsToShow = this.getRandom(Array.from(items), 4);
      itemsToShow.forEach(item => item.classList.remove('hidden'));
    }

    // from https://stackoverflow.com/a/19270021/5816097
    getRandom = function (arr, n) {
      var result = new Array(n),
          len = arr.length,
          taken = new Array(len);
      if (n > len)
        return arr;
      while (n--) {
          var x = Math.floor(Math.random() * len);
          result[n] = arr[x in taken ? taken[x] : x];
          taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    }
  }

  customElements.define('related-products', RelatedProducts);

  } catch(e) { console.error(e); }
})();
})();
